import { render, staticRenderFns } from "./GetBMXH.vue?vue&type=template&id=1461adde&scoped=true&"
import script from "./GetBMXH.vue?vue&type=script&lang=js&"
export * from "./GetBMXH.vue?vue&type=script&lang=js&"
import style0 from "./GetBMXH.vue?vue&type=style&index=0&id=1461adde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1461adde",
  null
  
)

export default component.exports